const C = require("../constants");

const categoryDialog = (data) => {
    return {
        type: C.CATEGORY_DIALOG,
        data
    }
};

export {categoryDialog};


// WEBPACK FOOTER //
// ./src/actions/CategoryDialogActions.js